import React, { Component } from "react";

class Phone extends Component {
  componentDidMount() {}

  render() {
    const ph = { phone: this.props.phone };
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={() =>
          this.props.handleNewSearchClick(this, "Phone", this.props.phone, ph)
        }
      >
        <span className={"background-color-transparent url-link"}>
          {this.props.phone}
        </span>
      </div>
    );
  }
}

export default Phone;



// WEBPACK FOOTER //
// ./src/components/searchresults/Phone.js